import React from "react";
import { useTranslation } from "react-i18next";
import ShowDoctors from "../components/doctors/ShowDoctors";

const Doctors: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-20">
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6 uppercase tracking-wide">
        {t("Docteurs")}
      </h2>
      <ShowDoctors />
    </div>
  );
};

export default Doctors;
